export default __webpack_public_path__ + "static/media/image.short-news.d247fbc7.png";